var map = {
	"./Lucidspark.webp": 62188,
	"./adobecapture.webp": 48561,
	"./adobeexpress.webp": 17747,
	"./adobefresco.webp": 34867,
	"./adobeillustrator.webp": 40966,
	"./affinitydesigner.webp": 91251,
	"./artStudio.webp": 67030,
	"./assembly.webp": 93174,
	"./bafkreig6ejfrg3pjf3pyt6jopx54qo763ujco3f5rbzmxkstndxjaxesku.webp": 65785,
	"./behance.webp": 99010,
	"./clipstudiopaint.webp": 25658,
	"./concepts.webp": 2827,
	"./coolors.webp": 38911,
	"./desygner.webp": 64659,
	"./figma.webp": 1894,
	"./flinto.webp": 26414,
	"./fontcase.webp": 615,
	"./freeform.webp": 30098,
	"./godaddystudio.webp": 34880,
	"./ifont.webp": 35636,
	"./linearitycurve.webp": 87308,
	"./lottiefiles.webp": 52192,
	"./lucidchart.webp": 11645,
	"./marvel.webp": 62009,
	"./maze.webp": 38481,
	"./miro.webp": 77215,
	"./origami.webp": 76660,
	"./paletter.webp": 95305,
	"./pastel.webp": 92971,
	"./pinterest.webp": 46372,
	"./procreate.webp": 33869,
	"./protopie.webp": 87054,
	"./savee.webp": 53090,
	"./sketch.webp": 82142,
	"./sketchbook.webp": 3559,
	"./tayasuisketches.webp": 2977,
	"./uxpin.webp": 56010,
	"./vectorize.webp": 20397,
	"./vsco.webp": 2367,
	"./zeplin.webp": 45160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75206;